// Co-branding header — логотип/инициалы дистрибьютора + название платформы.
// Один компонент для desktop sidebar (ClientShell) и mobile drawer (MobileNav)
// — иначе при изменении co-branding-блока в одном месте второе разъедется.
import { useDistributorBrand } from '../lib/distributor-brand'
import { brandForeground } from '@dss/design-system'

export function ClientBrandBlock() {
  const { current: brand } = useDistributorBrand()
  const brandName = brand?.name ?? 'Distribution Software'

  return (
    <div
      style={{
        padding: '8px 10px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        borderBottom: '1px solid var(--color-border-subtle)',
        marginBottom: 8,
      }}
    >
      {brand?.logoUrl ? (
        <img
          src={brand.logoUrl}
          alt={brand.name}
          width={28}
          height={28}
          style={{
            width: 28,
            height: 28,
            borderRadius: 6,
            objectFit: 'cover',
            background: brand.color,
          }}
        />
      ) : (
        <span
          aria-hidden="true"
          style={{
            width: 28,
            height: 28,
            borderRadius: 6,
            background: brand ? brand.color : 'var(--slate-900)',
            color: brand ? brandForeground(brand.color) : '#ffffff',
            flexShrink: 0,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 800,
            fontSize: 12,
          }}
        >
          {brand?.short ?? 'D'}
        </span>
      )}
      <div style={{ lineHeight: 1.3, minWidth: 0, overflowWrap: 'anywhere' }}>
        <div style={{ fontWeight: 600, fontSize: 13 }}>{brandName}</div>
        <div style={{ fontSize: 11, color: 'var(--color-text-tertiary)' }}>
          {brand ? 'на платформе DS' : 'клиентский портал'}
        </div>
      </div>
    </div>
  )
}
